import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import EditDesignPreferencePage from './EditDesignPreferencePage';
import { getdesignPreferencesData, updatePreferences, designPreferencesUpdate, resetCustPreferences } from 'src/actions/editDesignPreferenceAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
  return {
    designPreferenceData: state.editDesignPreferences.designPreferencesData,
    custDPrefData: state.editDesignPreferences.custDPrefData
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      // dispatch(getdesignPreferencesData);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
      dispatch(getdesignPreferencesData);
    },
    updatePreferences: (parentcode: string, listtype: string, occlusion: string, selectedValueDesc: string, fieldvalue: string) => {
      dispatch(updatePreferences(parentcode, listtype, occlusion, selectedValueDesc, fieldvalue));
    },
    onSubmitDesign: () => {
      dispatch(designPreferencesUpdate);
    },
    onReset: () => {
      dispatch(resetCustPreferences);
    },
  };
};

const EditDesignPreferencePageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditDesignPreferencePage);

export default EditDesignPreferencePageContainer;



// WEBPACK FOOTER //
// ./src/components/editdesignPreferences/EditDesignPreferencePageContainer.tsx